<template>
  <div class="order-group">
    <div class="group-header">
      <el-row
        justify="space-between"
        class="header-row"
      >
        <el-col :span="19">
          <el-row :gutter="16">
            <CustomInput
              v-model="localDescripcionCliente"
              label="Descripción Cliente Pedido"
              :spanColumn="12"
              :settings="{ placeholder: 'Descripción cliente', disabled: true }"
            />

            <CustomSearchAutocomplete
              v-model="localCliente"
              label="Cliente"
              :spanColumn="11"
              :minChars="3"
              :fieldKey="'Codigo'"
              :fieldLabel="'Descripcion'"
              :settings="{
                placeholder: 'Ingresar el cliente',
                clearable: true,
                size: 'default',
                disabled: clienteDisabled,
              }"
              :pagination="{
                enabled: true,
                page: 1,
                limit: 250,
              }"
              @search="handleClientSearch"
              @select="handleClienteSelect"
              @clear="handleClienteClear"
            />
          </el-row>
        </el-col>

        <el-col
          v-if="!(orderGroup.Cliente && orderGroup.Cliente.Codigo > 0)"
          :span="3"
          style="display: flex; flex-direction: column"
        >
          <div class="label">&nbsp;</div>
          <el-button
            type="primary"
            size="default"
            @click="goTo('page/prospects/edit')"
            >Agregar nuevo</el-button
          >
        </el-col>
      </el-row>

      <el-row
        justify="space-between"
        class="header-row"
      >
        <el-col :span="19">
          <el-row :gutter="16">
            <CustomInput
              v-model="localDescripcionVendedor"
              label="Descripción Vendedor Pedido"
              :spanColumn="12"
              :settings="{ placeholder: 'Descripción vendedor', disabled: true }"
            />

            <CustomSearchAutocomplete
              v-model="localVendedor"
              label="Vendedor"
              :spanColumn="11"
              :minChars="3"
              :fieldKey="'Codigo'"
              :fieldLabel="'Fullname'"
              :settings="{
                placeholder: 'Ingresar el vendedor',
                clearable: true,
                size: 'default',
                disabled: vendedorDisabled,
              }"
              :pagination="{
                enabled: true,
                page: 1,
                limit: 250,
              }"
              @search="handleVendedorSearch"
              @select="handleVendedorSelect"
              @clear="handleVendedorClear"
            />
          </el-row>
        </el-col>

        <el-col
          v-if="!vendedorDisabled"
          :span="3"
          style="display: flex; flex-direction: column"
        >
          <div class="label">&nbsp;</div>
          <el-button
            type="primary"
            size="default"
            @click="goTo('page/users/edit')"
            >Agregar nuevo</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="group-body">
      <el-row
        :gutter="16"
        style="padding-left: 8px; font-size: 0.8rem"
      >
        <el-col :span="4">
          <label>Cod Pedido / Cantidad</label>
        </el-col>
        <el-col :span="14">
          <label>Descripción Producto Pedido / Producto</label>
        </el-col>
        <el-col :span="4">
          <label>ET</label>
        </el-col>
      </el-row>
      <div
        v-for="order in orderGroup.orders"
        :key="order.codigoCantidad"
        class="order-line"
      >
        <OrderImportItemAOpProduct
          :order="order"
          @cantidad-change="handleCantidadChange"
          @producto-change="handleProductoChange"
          @especificacion-tecnica-change="handleEspecificacionTecnicaChange"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  nextTick,
  onMounted,
  ref,
  watch,
} from 'vue';
import { useProspectStore } from '@/views/prospects/stores/prospect_store.js';
import { useUserStore } from '@/views/users/stores/user_store.js';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomSearchAutocomplete from '@/shared/components/custom_search_autocomplete.vue';
import OrderImportItemAOpProduct from './order_import_item_a_op_product.vue';

const prospectStore = useProspectStore();
const { searchProspectsHTTP } = prospectStore;

const userStore = useUserStore();
const { searchUsersHTTP } = userStore;

const emit = defineEmits([
  'validation-change',
  'cliente-change',
  'vendedor-change',
  'order-change',
]);

const props = defineProps({
  orderGroup: { type: Object, required: true },
});

const localCliente = ref(null);
const localVendedor = ref(null);
const localDescripcionCliente = ref('');
const localDescripcionVendedor = ref('');
const clienteDisabled = ref(null);
const vendedorDisabled = ref(null);

watch(localCliente, (newValue, oldValue) => {
  if (
    oldValue &&
    oldValue.Descripcion &&
    oldValue.Descripcion.length >= 1 &&
    (!newValue || !newValue.Descripcion || newValue.Descripcion === '')
  ) {
    handleClienteClear();
  }
});

const handleClientSearch = async (searchParams, callback) => {
  let results = [];
  if (searchParams.query && searchParams.query.length >= 3 && searchParams.query !== 'null') {
    results = await searchProspectsHTTP(searchParams.query);
  }
  callback(results || []);
};

const handleClienteClear = () => {
  localCliente.value = null;
  emit('cliente-change', { groupKey: props.orderGroup.groupKey, cliente: null });
};

const handleClienteSelect = (cliente) => {
  emit('cliente-change', { groupKey: props.orderGroup.groupKey, cliente });
  handleValidation();
};

watch(localVendedor, (newValue, oldValue) => {
  if (
    oldValue &&
    oldValue.Fullname &&
    oldValue.Fullname.length >= 1 &&
    (!newValue || !newValue.Fullname || newValue.Fullname === '')
  ) {
    handleVendedorClear();
  }
});

const handleVendedorSearch = async (searchParams, callback) => {
  let results = [];
  if (searchParams.query && searchParams.query.length >= 3 && searchParams.query !== 'null') {
    results = await searchUsersHTTP(searchParams.query);
  }
  callback(results || []);
};

const handleVendedorClear = () => {
  localVendedor.value = null;
  emit('vendedor-change', { groupKey: props.orderGroup.groupKey, vendedor: null });
};

const handleVendedorSelect = (vendedor) => {
  emit('vendedor-change', { groupKey: props.orderGroup.groupKey, vendedor });
  handleValidation();
};

const handleCantidadChange = ({ order, cantidad }) => {
  emit('order-change', {
    orderCodigoCantidad: order.codigoCantidad,
    changes: { cantidad },
  });
  handleValidation();
};

const handleProductoChange = ({ order, producto }) => {
  emit('order-change', {
    orderCodigoCantidad: order.codigoCantidad,
    changes: { Producto: producto },
  });
  nextTick(() => {
    handleValidation();
  });
};

const handleEspecificacionTecnicaChange = ({ order, especificacionTecnica }) => {
  emit('order-change', {
    orderCodigoCantidad: order.codigoCantidad,
    changes: { EspecificacionTecnica: especificacionTecnica },
  });
  handleValidation();
};

const goTo = (route) => {
  const currentUrl = window.location.origin;
  window.open(`${currentUrl}/${route}`, '_blank', 'noopener,noreferrer');
};

const handleValidation = () => {
  nextTick(() => {
    const hasCliente = localCliente.value && localCliente.value.Codigo > 0;
    const hasVendedor = localVendedor.value && localVendedor.value.Codigo > 0;

    const allOrdersValid = props.orderGroup.orders.every((order) => {
      const hasProducto = order.Producto && order.Producto.Codigo > 0;
      return order.cantidad > 0 && hasProducto;
    });

    const isValid = hasCliente && hasVendedor && allOrdersValid;

    emit('validation-change', { groupKey: props.orderGroup.groupKey, isValid });
  });
};

onMounted(() => {
  localCliente.value = props.orderGroup.Cliente;
  localVendedor.value = props.orderGroup.Vendedor;
  clienteDisabled.value = props.orderGroup.Cliente && props.orderGroup.Cliente.Codigo > 0;
  vendedorDisabled.value = props.orderGroup.Vendedor && props.orderGroup.Vendedor.Codigo > 0;
  handleValidation();
});
</script>

<style scoped>
.order-group {
  border: 2px solid var(--el-border-color-light);
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;
}

.group-header {
  padding: 16px;
  background: var(--el-fill-color-light);
  border-bottom: 2px solid var(--el-border-color);
}

.header-row {
  margin-bottom: 12px;
}

.header-row:last-child {
  margin-bottom: 0;
}

.group-body {
  padding: 12px;
  font-weight: bold;
}

.order-line {
  border: 1px solid var(--el-border-color-lighter);
  border-radius: 4px;
  margin-bottom: 8px;
  background: var(--el-fill-color-blank);
}

.order-line:last-child {
  margin-bottom: 0;
}
</style>
